import { render, staticRenderFns } from "./LayoutSettings.vue?vue&type=template&id=69c3c23b"
import script from "./LayoutSettings.vue?vue&type=script&lang=js"
export * from "./LayoutSettings.vue?vue&type=script&lang=js"
import style0 from "./LayoutSettings.vue?vue&type=style&index=0&id=69c3c23b&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c3c23b')) {
      api.createRecord('69c3c23b', component.options)
    } else {
      api.reload('69c3c23b', component.options)
    }
    module.hot.accept("./LayoutSettings.vue?vue&type=template&id=69c3c23b", function () {
      api.rerender('69c3c23b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Modal/LayoutSettings.vue"
export default component.exports